import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20top%20down%20flat%20lay%20of%20a%20modern%20productive%20workspace%20with%20a%20laptop%20displaying%20beautiful%20colorful%20spreadsheet%20interface%20with%20dashboard%20charts%20and%20organized%20data%20tables%2C%20surrounded%20by%20a%20white%20ceramic%20coffee%20cup%20with%20gentle%20steam%20rising%2C%20a%20small%20green%20succulent%20plant%20in%20a%20terracotta%20pot%2C%20a%20brass%20pen%20on%20a%20leather%20notebook%2C%20and%20a%20pair%20of%20stylish%20reading%20glasses%2C%20soft%20warm%20natural%20lighting%20from%20above%2C%20cream%20beige%20and%20soft%20sage%20green%20color%20scheme%2C%20editorial%20productivity%20lifestyle%20photography%20with%20refined%20minimalist%20composition%20and%20soft%20gentle%20shadows&width=1600&height=600&seq=cta-vigorbuy-new-v2-2026&orientation=landscape"
          alt="Vigorbuy Spreadsheet workspace"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/55"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-white mb-4">
          Start Exploring Vigorbuy Spreadsheet Resources Today
        </h2>
        <p className="text-white/75 text-base md:text-lg max-w-xl mx-auto mb-8">
          Access professional templates, expert guides, and comprehensive resources to transform your spreadsheet workflow.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl text-base font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-external-link-line text-lg"></i>
            Visit Official Website
          </a>
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl text-base font-semibold bg-white/15 backdrop-blur-sm border border-white/25 text-white hover:bg-white/25 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-book-open-line text-lg"></i>
            Read Complete Guide
          </Link>
        </div>
      </div>
    </section>
  );
}